'use strict';

angular.module('shiftTraderApp')
  .controller('promptTradeDialogCtrl', function ($scope, $uibModalInstance, trade, mode, me, myWorkPeriods, ShiftTradeResponsesResource) {
    $scope.trade = trade;
    $scope.mode = mode;
    $scope.me = me;
    $scope.myWorkPeriods = myWorkPeriods;

    $scope.form = {
      message: ''
    };

    $scope.close = function() {
      $uibModalInstance.dismiss('close');
    };

    var acceptanceCodes = {
      accept: 'ACCEPTED',
      decline: 'REJECTED',
      message: 'MESSAGE',
      approve: 'APPROVED',
      disapprove: 'DISAPPROVED'
    };

    $scope.buttonText = function() {
      if ($scope.mode.mode === 'accept') {
        return 'Accept';
      } else if ($scope.mode.mode === 'decline') {
        return 'Decline';
      } else if ($scope.mode.mode === 'approve') {
        return 'Approve';
      } else {
        return 'Disapprove';
      }
    };

    //used to check if a person can accept/reject the giveaway
    // checking to see if the person is already working that day
    $scope.giveawayAllowed = $scope.trade.$isGiveaway() && _.all(_.filter($scope.myWorkPeriods, function(wp) {
      return wp.$isAssigned() && wp.user.id === $scope.me.id && wp.$isPublished();
    }), function(w) {
      var overlap = w.range_twix.overlaps($scope.trade.work_period.range_twix) &&
        Math.abs(w.range_twix.intersection($scope.trade.work_period.range_twix).length('minutes')) > 0;
      if (overlap) {
        $scope.overlappingWorkPeriod = w;
      }
      return !overlap;
    });

    $scope.triggerAction = function() {
      var response = new ShiftTradeResponsesResource();
      response.user_id = $scope.me.id;
      if(!$scope.trade.$isGiveaway()) {
        response.work_period_id = $scope.trade.trade_work_period.id;
      }

      if (mode.mode === 'disapprove') {
        if (!$scope.trade.$isGiveaway() && _.where($scope.trade.shift_trade_responses, {acceptance_code: 10}).length > 0) {
          response.shift_trade_response_id = _($scope.trade.shift_trade_responses).where({acceptance_code: 10}).pluck('id').first();
        } else {
          response.shift_trade_response_id = null;
        }
      } else if (mode.mode === 'approve' && _.where($scope.trade.shift_trade_responses, {acceptance_code: 10}).length > 0) {
        response.shift_trade_response_id = _($scope.trade.shift_trade_responses).where({acceptance_code: 10}).pluck('id').first();
      } else {
        response.shift_trade_response_id = null;
      }

      response.shift_trade_id = $scope.trade.id;
      response.message = $scope.form.message;
      response.acceptance_code = acceptanceCodes[mode.mode];

      response.$save(function (response) {
        console.log(response);
        $uibModalInstance.close(response);
      });
    };

  });
